import { Component } from '@angular/core';

@Component({
  selector: 'app-ui-badges',
  templateUrl: './ui-badges.component.html',
  styleUrls: ['./ui-badges.component.css']
})
export class UiBadgesComponent {
  /**
   * Header button list show
   */
  Settingicon = true;
  Menuoption = 'center'
}
